import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BookOpen, ArrowUpRight, ShoppingBag, ShoppingCart } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LinkHub = () => {
  const [guides, setGuides] = useState([]);
  const [directLinks, setDirectLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/guides`).then((r) => setGuides(r.data || [])).catch(() => setGuides([])),
      axios.get(`${API}/direct-links`).then((r) => setDirectLinks(r.data || [])).catch(() => setDirectLinks([])),
    ]).finally(() => setLoading(false));
  }, []);

  const fixedLinks = [
    { to: '/tienda', label: 'Tienda de herramientas', icon: ShoppingBag, testid: 'linkhub-tienda' },
  ];

  return (
    <div
      className="min-h-screen bg-slate-950 text-white flex flex-col items-center px-5 py-12"
      data-testid="linkhub-page"
      style={{
        backgroundImage:
          'radial-gradient(circle at 20% 0%, rgba(220,38,38,0.18), transparent 45%), radial-gradient(circle at 90% 100%, rgba(220,38,38,0.10), transparent 40%)',
      }}
    >
      <div className="w-full max-w-md mx-auto flex flex-col items-center">
        {/* Brand */}
        <div className="text-center mb-2">
          <span className="text-3xl font-extrabold tracking-tight">
            DRYWALL <span className="bg-red-600 text-white px-2 py-0.5 rounded">TOOLS</span>
          </span>
        </div>
        <p className="text-slate-300 text-center text-sm mb-1">Drywall Desing LLC</p>
        <p className="text-slate-400 text-center text-sm max-w-xs mb-8">
          🔧 Trucos y herramientas de pladur que <span className="text-white font-semibold">sí funcionan</span>.
          Guías, comparativas y tienda 👇
        </p>

        {/* Guide links (dynamic) */}
        <div className="w-full space-y-3" data-testid="linkhub-links">
          {loading ? (
            <div className="text-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-4 border-red-600 border-t-transparent mx-auto" />
            </div>
          ) : (
            <>
              {/* Direct affiliate links (external) */}
              {directLinks.map((l) => (
                <a
                  key={l.id}
                  href={l.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`linkhub-direct-${l.id}`}
                  className="group flex items-center gap-3 w-full bg-white/5 hover:bg-white/10 border border-white/10 hover:border-red-500/60 rounded-2xl px-5 py-4 transition-colors duration-200"
                >
                  <ShoppingCart size={18} className="text-red-500 shrink-0" />
                  <span className="flex-1 font-medium text-sm leading-snug">
                    {l.label}
                    {l.price_text && <span className="text-slate-400 font-normal"> · {l.price_text}</span>}
                  </span>
                  <ArrowUpRight
                    size={18}
                    className="text-slate-400 group-hover:text-red-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all shrink-0"
                  />
                </a>
              ))}

              {guides.map((g) => (
                <Link
                  key={g.slug}
                  to={`/guias/${g.slug}`}
                  data-testid={`linkhub-guide-${g.slug}`}
                  className="group flex items-center gap-3 w-full bg-white/5 hover:bg-white/10 border border-white/10 hover:border-red-500/60 rounded-2xl px-5 py-4 transition-colors duration-200"
                >
                  <BookOpen size={18} className="text-red-500 shrink-0" />
                  <span className="flex-1 font-medium text-sm leading-snug">{g.title}</span>
                  <ArrowUpRight
                    size={18}
                    className="text-slate-400 group-hover:text-red-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all shrink-0"
                  />
                </Link>
              ))}

              {fixedLinks.map((l) => {
                const Icon = l.icon;
                return (
                  <Link
                    key={l.to}
                    to={l.to}
                    data-testid={l.testid}
                    className="group flex items-center gap-3 w-full bg-red-600 hover:bg-red-700 rounded-2xl px-5 py-4 transition-colors duration-200"
                  >
                    <Icon size={18} className="text-white shrink-0" />
                    <span className="flex-1 font-semibold text-sm">{l.label}</span>
                    <ArrowUpRight size={18} className="text-white group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform shrink-0" />
                  </Link>
                );
              })}
            </>
          )}
        </div>

        {/* Affiliate disclosure */}
        <p className="text-[11px] text-slate-500 text-center mt-10 max-w-xs leading-relaxed">
          Como afiliados de Amazon, ganamos por compras válidas realizadas a través de algunos enlaces, sin coste adicional para ti.
        </p>
      </div>
    </div>
  );
};

export default LinkHub;
